import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { motion } from "framer-motion";
import styled from "styled-components";
export const thumbSize = 16;
export const thumbHeight = 4;
export const ThumbStyle = styled(motion.div) `
  position: absolute;
  height: ${thumbSize}px;
  width: ${thumbSize}px;
  user-select: none;
  border: 4px solid ${color.font.link.default};
  border-radius: 100%;
  background-color: ${color.base.white};
  cursor: grab;

  &.isDragging,
  &:hover {
    background-color: ${color.font.link.default};
  }

  &.disabled {
    border-color: ${color.background.darker};
    background-color: ${color.base.white};
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGh1bWJTdHlsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NsaWRlci9zdHlsZWQvVGh1bWJTdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDdkUsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsRUFBRSxDQUFDO0FBQzVCLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxDQUFDLENBQUM7QUFFN0IsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7O1lBRWhDLFNBQVM7V0FDVixTQUFTOztzQkFFRSxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPOztzQkFFdkIsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLOzs7Ozt3QkFLZCxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPOzs7O29CQUkzQixLQUFLLENBQUMsVUFBVSxDQUFDLE1BQU07d0JBQ25CLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSzs7O0NBR3ZDLENBQUMifQ==